import { z } from "zod";
import { DEMO_DISCLAIMER_ENABLED } from "@/config/authFeatures";

// Sign-in carries no password policy — only the ceiling the server accepts
// (50 for AD, 64 for a local account). Rules about length and characters
// belong on the screens that set a password; here they can only mislead,
// because whether the password is right is the server's answer, not ours.
// There is no `.trim()` either: a password is sent exactly as typed, and
// trimming it made an account whose password starts or ends with a space
// impossible to sign in to.
const adBase = z.object({
  employeeId: z
    .string({ required_error: "Corporate ID is required" })
    .trim()
    .min(1, "Corporate ID is required")
    .min(3, "Corporate ID must be at least 3 characters")
    .max(50, "Corporate ID must be 50 characters or less")
    .regex(/^[a-zA-Z0-9._ ]+$/, "Corporate ID must contain only letters and numbers"),
  password: z.string().max(50, "Password must be 50 characters or less"),
});

const localBase = z.object({
  email: z.string({ required_error: "Email is required" }).trim().min(1, "Email is required").email("Enter a valid email address"),
  password: z.string().max(64, "Password must be 64 characters or less"),
});

const disclaimerField = z.boolean().refine((val) => val === true, {
  message: "Please acknowledge the demo-site notice to continue",
});

export const adLoginSchema     = DEMO_DISCLAIMER_ENABLED ? adBase.extend({ acknowledged: disclaimerField })    : adBase;
export const localSigninSchema = DEMO_DISCLAIMER_ENABLED ? localBase.extend({ acknowledged: disclaimerField }) : localBase;

export const adLoginValue = {
  employeeId: '',
  password: '',
};

export const localLoginValue = {
  email: '',
  password: '',
};
